import { Paper, Typography } from "@mui/material";
import SensorChart from "../chart/sensorChart.component";
import { useSelector } from "react-redux";
import { useMemo } from "react";
import { useIsMobile } from "../../hook/useIsMobile";

function normalizeMeasure(measure) {
  if (!measure) return measure;

  const measureMap = {
    soil_electrical_conductivity: "soil_ec",
  };

  if (measureMap[measure]) {
    return measureMap[measure];
  }

  const suffixesToExtract = ["temperature", "moisture"];
  for (const suffix of suffixesToExtract) {
    if (measure.endsWith(suffix)) {
      return suffix;
    }
  }

  return measure;
}

const MonitoringSensorChart = ({ measures, sensors, currentSensorId }) => {
  const isMobile = useIsMobile();

  const chartData = useSelector((state) => state.sensorData?.data);

  const transformedChartData = useMemo(() => {
    if (!chartData || !currentSensorId) return {};

    const result = {};
    const normalizedMeasures = measures.map(normalizeMeasure);

    normalizedMeasures.forEach((normalizedMeasure, index) => {
      const key = `${currentSensorId}_${normalizedMeasure}`;
      if (chartData[key]) {
        result[measures[index]] = chartData[key];
      }
    });

    return result;
  }, [chartData, currentSensorId, measures]);

  return (
    <Paper
      elevation={0}
      sx={{
        width: isMobile ? "100%" : "50%",
        height: isMobile ? "300px" : "350px",
        padding: 1,
      }}
    >
      <Typography fontWeight="bold" fontSize="12px">
        Valori attuali
      </Typography>
      <SensorChart
        chartData={transformedChartData}
        selectedMeasures={measures}
        sensors={sensors}
      />
    </Paper>
  );
};

export default MonitoringSensorChart;
